module.exports = __webpack_public_path__ + "saudi-arabia.svg?239857cafadaf65e9a26030eaedc5066";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/saudi-arabia.svg
// module id = 285
// module chunks = 10